"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapNumHalfBathroomsToEzLynxNumHalfBathrooms = exports.mapNumFullBathroomsToEzLynxNumFullBathrooms = exports.mapNumStoriesToEzLynxNumStories = exports.mapRoofShapeToEzLynxRoofShape = exports.mapFoundationToEzlynxFoundation = exports.mapHeatingTypeToEzLynxHeatingType = exports.mapRoofCoveringTypeToEzLynxRoofType = exports.mapStructureTypeToEzLynxStructureType = exports.mapConstructionTypeToEzLynxConstructionType = void 0;
const non_normal_types_1 = require("../../non-normal-types");
const mapConstructionTypeToEzLynxConstructionType = (exteriorWallType) => {
    switch (exteriorWallType?.toLowerCase()) {
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.adobe.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.adobe.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.adobe;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.aluminumSiding.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.aluminumVinyl.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.aluminumVinyl;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.asbestosReplacement.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.cementFiber.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.cementFiberShingles.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.cementFiberShingles;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.autoclavedConcreteExposed.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.autoclavedConcretePainted.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.concreteReinforced.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.pouredConcrete.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.pouredConcrete;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.brickMasonry.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.brickBlockBackup.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.brick.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.brick;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.brownstone.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.solidBrownstone.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.solidBrownstone;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.clapboard.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.clapboard.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.clapboard;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.concreteBlock.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.concreteBlockPainted.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.concreteDecorativeBlockPainted.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.concreteDecorativeBlockPainted;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.drivit.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.exteriorInsulation.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.exteriorInsulation;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.woodSiding.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.engineeredWoodSiding.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.sidingWood.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.sidingWood;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.localStone.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.solidStone.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.solidStone.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.solidStone;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.metalSiding.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.sidingAluminum.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.sidingAluminum;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.logSiding.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.logs.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.logs;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.steelSiding.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.sidingSteel.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.sidingSteel;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.stucco.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.stuccoMasonry.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.stuccoHalfTimber.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.stuccoSlickFinish.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.stuccoSmoothCoat.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.stuccoTuscanFinish.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.stucco.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.stucco;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.veneerCommonBrick.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.veneerFaceBrick.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.veneerSyntheticBrick.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.brickVeneer.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.brickVeneer;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.veneerStone.toLowerCase():
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.veneerSyntheticStone.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.stoneVeneer.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.stoneVeneer;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.woodshakeShingle.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.woodShakes.toLowerCase():
            return non_normal_types_1.EzLynxConstructionTypeEnum.woodShakes;
        case non_normal_types_1.E2ValueExteriorWallTypeEnum.vinylSiding.toLowerCase():
        case non_normal_types_1.EzLynxConstructionTypeEnum.sidingVinyl.toLowerCase():
        default:
            return non_normal_types_1.EzLynxConstructionTypeEnum.sidingVinyl;
    }
};
exports.mapConstructionTypeToEzLynxConstructionType = mapConstructionTypeToEzLynxConstructionType;
const mapStructureTypeToEzLynxStructureType = (structureType) => {
    switch (structureType?.toLowerCase()) {
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.biLevel.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.biLevel.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.biLevel;
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.capeCod.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.capeCod.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.capeCod;
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonial.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialCustom.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialDutch.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialEarlyAmerican.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialEclectic.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialFrench.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialGerman.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialManor.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialNewEngland.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialPlantation.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialRevival.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialRevivalEclectic.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialSouthern.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialSpanish.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.colonialTract.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.colonial.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.colonial;
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.contemporary.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.contemporaryCalifornia.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.contemporaryEnglish.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.contemporaryFrench.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.contemporaryTudor.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.contemporary.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.contemporary;
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.splitEntry.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.splitFoyer.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.splitFoyer;
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.splitLevel.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.splitLevel.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.splitLevel;
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.townhouse.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.townhouseFederal.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.townhouseGeorgian.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.townhouse.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.townhouse;
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.townhouseEndUnit.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.townhouseFederalEndUnit.toLowerCase():
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.townhouseGeorgianEndUnit.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.townhouseEnd.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.townhouseEnd;
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.triLevel.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.triLevel.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.triLevel;
        case non_normal_types_1.E2ValueHomeStyleStructureTypeEnum.victorian.toLowerCase():
        case non_normal_types_1.EzLynxHomeStyleEnum.victorian.toLowerCase():
            return non_normal_types_1.EzLynxHomeStyleEnum.victorian;
        case non_normal_types_1.EzLynxHomeStyleEnum.dwelling.toLowerCase():
        default:
            return non_normal_types_1.EzLynxHomeStyleEnum.dwelling;
    }
};
exports.mapStructureTypeToEzLynxStructureType = mapStructureTypeToEzLynxStructureType;
const mapRoofCoveringTypeToEzLynxRoofType = (roofCoveringType) => {
    switch (roofCoveringType?.toLowerCase()) {
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.architecturalShingle.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.architecturalShingles.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.architecturalShingles;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.asphaltShinglesWithSolarPanels.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.steelWithSolarPanels.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.tileWithSolarPanels.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.solar.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.solar;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.cedarShingleShake.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.woodShake.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.woodShake.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.woodShake;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.clayTile.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.tileClay.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.tileClay;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.concreteTile.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.tileConcrete.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.tileConcrete;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.elastomeric.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.polyurethaneFoam.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.other.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.other;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.metalStandingSeam.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.metalCorrugated.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.metalRibbed.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.standingSeamMetal.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.steel.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.metalPitched.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.metalPitched;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.rubber.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.rubberPitched.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.rubberPitched;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.woodShingle.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.woodShingles.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.woodShingles;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.redSlate.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.slate.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.slateGraduated.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.slatePatterned.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.slateSynthetic.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.slate.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.slate;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.spanishTile.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.tileSpanish.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.tileSpanish;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.standingSeamCopper.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.copperPitched.toLowerCase():
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.copperPitched;
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.dimensionalAsphaltShingle.toLowerCase():
        case non_normal_types_1.E2ValueRoofCoveringTypeEnum.asphaltShingle.toLowerCase():
        case non_normal_types_1.EzLynxRoofCoveringTypeEnum.asphaltShingles.toLowerCase():
        default:
            return non_normal_types_1.EzLynxRoofCoveringTypeEnum.asphaltShingles;
    }
};
exports.mapRoofCoveringTypeToEzLynxRoofType = mapRoofCoveringTypeToEzLynxRoofType;
const mapHeatingTypeToEzLynxHeatingType = (heatingType) => {
    switch (heatingType?.toLowerCase()) {
        case non_normal_types_1.E2ValueHeatingTypeEnum.electric.toLowerCase():
        case non_normal_types_1.EzLynxHeatingTypeEnum.electric.toLowerCase():
            return non_normal_types_1.EzLynxHeatingTypeEnum.electric;
        case non_normal_types_1.E2ValueHeatingTypeEnum.liquidPropane.toLowerCase():
        case non_normal_types_1.EzLynxHeatingTypeEnum.other.toLowerCase():
            return non_normal_types_1.EzLynxHeatingTypeEnum.other;
        case non_normal_types_1.E2ValueHeatingTypeEnum.gas.toLowerCase():
        case non_normal_types_1.E2ValueHeatingTypeEnum.naturalGas.toLowerCase():
        case non_normal_types_1.EzLynxHeatingTypeEnum.gas.toLowerCase():
        default:
            return non_normal_types_1.EzLynxHeatingTypeEnum.gas;
    }
};
exports.mapHeatingTypeToEzLynxHeatingType = mapHeatingTypeToEzLynxHeatingType;
const mapFoundationToEzlynxFoundation = (foundationType) => {
    switch (foundationType?.toLowerCase()) {
        case non_normal_types_1.E2ValueFoundationTypeEnum.brick.toLowerCase():
        case non_normal_types_1.E2ValueFoundationTypeEnum.fieldstone.toLowerCase():
        case non_normal_types_1.E2ValueFoundationTypeEnum.hollandClayTile.toLowerCase():
        case non_normal_types_1.E2ValueFoundationTypeEnum.noPermanentFoundation.toLowerCase():
        case non_normal_types_1.E2ValueFoundationTypeEnum.pouredConcrete.toLowerCase():
        case non_normal_types_1.E2ValueFoundationTypeEnum.stone.toLowerCase():
        case non_normal_types_1.E2ValueFoundationTypeEnum.stoneRubbleMortar.toLowerCase():
        case non_normal_types_1.E2ValueFoundationTypeEnum.treatedWood.toLowerCase():
        case non_normal_types_1.EzLynxFoundationTypeEnum.other.toLowerCase():
            return non_normal_types_1.EzLynxFoundationTypeEnum.other;
        case non_normal_types_1.E2ValueFoundationTypeEnum.pier.toLowerCase():
        case non_normal_types_1.EzLynxFoundationTypeEnum.piers.toLowerCase():
            return non_normal_types_1.EzLynxFoundationTypeEnum.piers;
        case non_normal_types_1.E2ValueFoundationTypeEnum.pierBeam.toLowerCase():
        case non_normal_types_1.EzLynxFoundationTypeEnum.pierAndBeam.toLowerCase():
            return non_normal_types_1.EzLynxFoundationTypeEnum.pierAndBeam;
        case non_normal_types_1.E2ValueFoundationTypeEnum.pilings.toLowerCase():
        case non_normal_types_1.EzLynxFoundationTypeEnum.pilingsOther.toLowerCase():
            return non_normal_types_1.EzLynxFoundationTypeEnum.pilingsOther;
        case non_normal_types_1.E2ValueFoundationTypeEnum.concreteBlock.toLowerCase():
        case non_normal_types_1.E2ValueFoundationTypeEnum.concreteSlab.toLowerCase():
        case non_normal_types_1.EzLynxFoundationTypeEnum.slab.toLowerCase():
        default:
            return non_normal_types_1.EzLynxFoundationTypeEnum.slab;
    }
};
exports.mapFoundationToEzlynxFoundation = mapFoundationToEzlynxFoundation;
const mapRoofShapeToEzLynxRoofShape = (roofShapeType) => {
    switch (roofShapeType?.toLowerCase()) {
        case non_normal_types_1.E2ValueRoofShapeTypeEnum.gambrel.toLowerCase():
        case non_normal_types_1.EzlynxRoofShapeEnum.gambrel.toLowerCase():
            return non_normal_types_1.EzlynxRoofShapeEnum.gambrel;
        case non_normal_types_1.E2ValueRoofShapeTypeEnum.hip.toLowerCase():
        case non_normal_types_1.E2ValueRoofShapeTypeEnum.hipGableDormers.toLowerCase():
        case non_normal_types_1.EzlynxRoofShapeEnum.hip.toLowerCase():
            return non_normal_types_1.EzlynxRoofShapeEnum.hip;
        case non_normal_types_1.E2ValueRoofShapeTypeEnum.mansard.toLowerCase():
        case non_normal_types_1.EzlynxRoofShapeEnum.mansard.toLowerCase():
            return non_normal_types_1.EzlynxRoofShapeEnum.mansard;
        case non_normal_types_1.E2ValueRoofShapeTypeEnum.multiLevelContemporary.toLowerCase():
        case non_normal_types_1.E2ValueRoofShapeTypeEnum.saltBox.toLowerCase():
        case non_normal_types_1.EzlynxRoofShapeEnum.other.toLowerCase():
            return non_normal_types_1.EzlynxRoofShapeEnum.other;
        case non_normal_types_1.E2ValueRoofShapeTypeEnum.shed.toLowerCase():
        case non_normal_types_1.EzlynxRoofShapeEnum.shed.toLowerCase():
            return non_normal_types_1.EzlynxRoofShapeEnum.shed;
        case non_normal_types_1.E2ValueRoofShapeTypeEnum.gable.toLowerCase():
        case non_normal_types_1.E2ValueRoofShapeTypeEnum.gableDormers.toLowerCase():
        case non_normal_types_1.EzlynxRoofShapeEnum.gable.toLowerCase():
        default:
            return non_normal_types_1.EzlynxRoofShapeEnum.gable;
    }
};
exports.mapRoofShapeToEzLynxRoofShape = mapRoofShapeToEzLynxRoofShape;
const mapNumStoriesToEzLynxNumStories = (stories) => {
    if (!stories)
        return 1;
    if (stories > 5)
        return 5;
    return stories;
};
exports.mapNumStoriesToEzLynxNumStories = mapNumStoriesToEzLynxNumStories;
const mapNumFullBathroomsToEzLynxNumFullBathrooms = (bathrooms) => {
    if (!bathrooms)
        return "1";
    if (bathrooms >= 10)
        return "10+";
    return String(bathrooms);
};
exports.mapNumFullBathroomsToEzLynxNumFullBathrooms = mapNumFullBathroomsToEzLynxNumFullBathrooms;
const mapNumHalfBathroomsToEzLynxNumHalfBathrooms = (halfBathrooms) => {
    if (!halfBathrooms)
        return "1";
    if (halfBathrooms >= 5)
        return "5+";
    return String(halfBathrooms);
};
exports.mapNumHalfBathroomsToEzLynxNumHalfBathrooms = mapNumHalfBathroomsToEzLynxNumHalfBathrooms;
